import { default as reset_45passwordTqSza1NXokMeta } from "/home/runner/work/parmazip-patient/parmazip-patient/src/pages/auth-management/reset-password.vue?macro=true";
import { default as auth_45managementVSTfQkaA5xMeta } from "/home/runner/work/parmazip-patient/parmazip-patient/src/pages/auth-management.vue?macro=true";
import { default as _91room_93FVjEEn1CyMMeta } from "/home/runner/work/parmazip-patient/parmazip-patient/src/pages/calls/[room].vue?macro=true";
import { default as patient_45appointmentszOKuEJUhHYMeta } from "/home/runner/work/parmazip-patient/parmazip-patient/src/pages/dashboard/patient-appointments.vue?macro=true";
import { default as patient_45billingEIcMryaRwEMeta } from "/home/runner/work/parmazip-patient/parmazip-patient/src/pages/dashboard/patient-billing.vue?macro=true";
import { default as patient_45notifsB9rNY6xtteMeta } from "/home/runner/work/parmazip-patient/parmazip-patient/src/pages/dashboard/patient-notifs.vue?macro=true";
import { default as patient_45profilelUAim7WZLBMeta } from "/home/runner/work/parmazip-patient/parmazip-patient/src/pages/dashboard/patient-profile.vue?macro=true";
import { default as patient_45recordsIqVp8iVtNKMeta } from "/home/runner/work/parmazip-patient/parmazip-patient/src/pages/dashboard/patient-records.vue?macro=true";
import { default as patient3tyg2rVCMpMeta } from "/home/runner/work/parmazip-patient/parmazip-patient/src/pages/dashboard/patient.vue?macro=true";
import { default as dashboardpMITmnE2MbMeta } from "/home/runner/work/parmazip-patient/parmazip-patient/src/pages/dashboard.vue?macro=true";
import { default as indexW1fjJTkS5aMeta } from "/home/runner/work/parmazip-patient/parmazip-patient/src/pages/demo/index.vue?macro=true";
import { default as patientWWNtsjheJ2Meta } from "/home/runner/work/parmazip-patient/parmazip-patient/src/pages/demo/patient.vue?macro=true";
import { default as eulabGVeYaEifZMeta } from "/home/runner/work/parmazip-patient/parmazip-patient/src/pages/eula.vue?macro=true";
import { default as forgot_45passwordmSJz3OjCZZMeta } from "/home/runner/work/parmazip-patient/parmazip-patient/src/pages/forgot-password.vue?macro=true";
import { default as indexcMQmQwmYxCMeta } from "/home/runner/work/parmazip-patient/parmazip-patient/src/pages/index.vue?macro=true";
import { default as login8xwz8A4H2EMeta } from "/home/runner/work/parmazip-patient/parmazip-patient/src/pages/login.vue?macro=true";
import { default as privacy_45policyQpI8r2HQLdMeta } from "/home/runner/work/parmazip-patient/parmazip-patient/src/pages/privacy-policy.vue?macro=true";
import { default as account_45typelMLk99UY92Meta } from "/home/runner/work/parmazip-patient/parmazip-patient/src/pages/signup/account-type.vue?macro=true";
import { default as accountJ1JUqJXzNkMeta } from "/home/runner/work/parmazip-patient/parmazip-patient/src/pages/signup/account.vue?macro=true";
import { default as personal_45detailsvEDIgV8gBeMeta } from "/home/runner/work/parmazip-patient/parmazip-patient/src/pages/signup/personal-details.vue?macro=true";
import { default as successn48Q1U0KvoMeta } from "/home/runner/work/parmazip-patient/parmazip-patient/src/pages/signup/success.vue?macro=true";
import { default as verify_45email0byR9IumfTMeta } from "/home/runner/work/parmazip-patient/parmazip-patient/src/pages/signup/verify-email.vue?macro=true";
import { default as signupuBXb4haGq4Meta } from "/home/runner/work/parmazip-patient/parmazip-patient/src/pages/signup.vue?macro=true";
import { default as terms_45of_45useaKETHneZ6eMeta } from "/home/runner/work/parmazip-patient/parmazip-patient/src/pages/terms-of-use.vue?macro=true";
import { default as test_45sentrytcBOkY3ivNMeta } from "/home/runner/work/parmazip-patient/parmazip-patient/src/pages/test-sentry.vue?macro=true";
export default [
  {
    name: "auth-management",
    path: "/auth-management",
    meta: auth_45managementVSTfQkaA5xMeta || {},
    component: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/pages/auth-management.vue").then(m => m.default || m),
    children: [
  {
    name: "auth-management-reset-password",
    path: "reset-password",
    component: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/pages/auth-management/reset-password.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "calls-room",
    path: "/calls/:room()",
    meta: _91room_93FVjEEn1CyMMeta || {},
    component: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/pages/calls/[room].vue").then(m => m.default || m)
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/pages/dashboard.vue").then(m => m.default || m),
    children: [
  {
    name: "dashboard-patient-appointments",
    path: "patient-appointments",
    meta: patient_45appointmentszOKuEJUhHYMeta || {},
    component: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/pages/dashboard/patient-appointments.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-patient-billing",
    path: "patient-billing",
    meta: patient_45billingEIcMryaRwEMeta || {},
    component: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/pages/dashboard/patient-billing.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-patient-notifs",
    path: "patient-notifs",
    meta: patient_45notifsB9rNY6xtteMeta || {},
    component: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/pages/dashboard/patient-notifs.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-patient-profile",
    path: "patient-profile",
    meta: patient_45profilelUAim7WZLBMeta || {},
    component: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/pages/dashboard/patient-profile.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-patient-records",
    path: "patient-records",
    meta: patient_45recordsIqVp8iVtNKMeta || {},
    component: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/pages/dashboard/patient-records.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-patient",
    path: "patient",
    meta: patient3tyg2rVCMpMeta || {},
    component: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/pages/dashboard/patient.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "demo",
    path: "/demo",
    component: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/pages/demo/index.vue").then(m => m.default || m)
  },
  {
    name: "demo-patient",
    path: "/demo/patient",
    component: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/pages/demo/patient.vue").then(m => m.default || m)
  },
  {
    name: "eula",
    path: "/eula",
    component: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/pages/eula.vue").then(m => m.default || m)
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordmSJz3OjCZZMeta || {},
    component: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/pages/forgot-password.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexcMQmQwmYxCMeta || {},
    component: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "login",
    path: "/login",
    meta: login8xwz8A4H2EMeta || {},
    component: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: "signup",
    path: "/signup",
    meta: signupuBXb4haGq4Meta || {},
    component: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/pages/signup.vue").then(m => m.default || m),
    children: [
  {
    name: "signup-account-type",
    path: "account-type",
    component: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/pages/signup/account-type.vue").then(m => m.default || m)
  },
  {
    name: "signup-account",
    path: "account",
    component: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/pages/signup/account.vue").then(m => m.default || m)
  },
  {
    name: "signup-personal-details",
    path: "personal-details",
    component: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/pages/signup/personal-details.vue").then(m => m.default || m)
  },
  {
    name: "signup-success",
    path: "success",
    component: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/pages/signup/success.vue").then(m => m.default || m)
  },
  {
    name: "signup-verify-email",
    path: "verify-email",
    component: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/pages/signup/verify-email.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "terms-of-use",
    path: "/terms-of-use",
    component: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/pages/terms-of-use.vue").then(m => m.default || m)
  },
  {
    name: "test-sentry",
    path: "/test-sentry",
    component: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/pages/test-sentry.vue").then(m => m.default || m)
  }
]